// CN marketplace configurations related to detail page scope.
import { Common } from '@/configs';

const PAGE_TITLE_NAME = {
  UNIT_CONVERSION_TABLE: 'Unit Conversion Table',
  ELECTRICAL_VOLTAGE_USAGE_INSTRUCTION:
    'Amazon Global Store Electrical Voltage Usage Instructions',
  BEAUTY_SHOPPING_GUIDE: 'Tips for Purchasing Global Stores Beauty Products',
  CUSTOMS_CLEARANCE_INFO: 'Customs Clearance Information'
};

const unitConversionTipData = {
  images: [
    `${Common.MEDIA_CENTRAL_LINKS.PREFIX_IMAGE_URL}ZCNXUHAO/store/size.png`
  ]
};

const electricalVoltageTipData = {
  title: 'Power Usage Tips',
  paragraphs: [
    [
      "Welcome to Amazon's 'Global Store'. All 'Global Store' products are 100% from Amazon's Global Stores sites. Electrical products are designed for Global Stores voltage environments (such as 110 volts commonly used in the US and Japan). Please ensure the product supports the voltage of your location (e.g.  220 volts for domestic use in China) before purchasing. If there is no specific introduction on the product detail page  please visit the brand's official website to fully understand the voltage and other power requirements. If the product does not support your local voltage  you will need an appropriate transformer (also known as 'voltage converter'  'power transformer'  etc.) to adjust the voltage before use. The transformer's rated power must be greater than the appliance's rated power to avoid damage. If the appliance plug shape does not match the socket type  you will need to purchase a corresponding conversion plug. When purchasing and using transformers and conversion plugs  please strictly follow their instructions and pay attention to electrical safety.",
      'Note! Voltage range and socket type have different meanings; when using electrical products  both voltage and socket requirements must be met. For details  please refer to the table below.'
    ],
    []
  ],
  images: [
    `${Common.MEDIA_CENTRAL_LINKS.PREFIX_IMAGE_URL}hehehe/power/power_01`,
    ''
  ],
  lists: [
    [
      'Find the nameplate on the product (usually on the back).',
      'Check the rated power (in W or Watts). If this value is not available  calculate it by multiplying the rated voltage by the rated current.',
      " When choosing a transformer  select one with a rated power greater than the appliance's rated power. "
    ],
    []
  ]
};

const beautyShoppingTipData = {
  title: 'Tips for Purchasing Global Stores Beauty Products',
  paragraphs: [
    "Welcome to Amazon's 'Global Store'. As Amazon Global Store products are directly shipped from Amazon's Global Stores sites and are genuine Global Stores sales products  they are subject to the laws  regulations  standards  norms  and customs of the place of sale  and therefore may differ from products sold within China in the following aspects: ",
    ''
  ],
  lists: [
    '1. How to identify the production date and expiration date of the product?',
    '2. If there is no production date and expiration date marked  how to use the product?'
  ],
  listParagraphs: [
    [
      [
        'Products marked with a production date and expiration date usually have the following marking methods: ',
        'MFD  MFG  MAN (abbreviations for Manufacturing Date)  all mean the manufacturing/production date.'
      ],
      [
        'For example  MFG 200515 09:30 means the production date is May 20  2015  at 09:30.',
        'MFG 129-2014 means the production date is the 129th day of 2014.',
        'EXP (abbreviation for Expiry Date) refers to the expiration date.'
      ],
      [
        'For example  EXP 03/17 means the expiration date is March 2017.',
        'Exp Nov 17 means the expiration date is November 2017.',
        'BB  BBE (abbreviations for Best Before): Best before this date. '
      ],
      [
        'For example: DEC 2019 means the best use date of this product is December 2019.'
      ]
    ],
    [
      [
        ' In Europe  generally  products that can be used for more than 30 months do not have a production date marked. Many European products only have a batch number on the packaging without a production date  and there may be no seal at the opening. The shelf life of this type of product is defaulted to 12 months after opening. The packaging usually has the following icon to indicate the use period after opening.'
      ],
      [
        `<img src='${Common.MEDIA_CENTRAL_LINKS.PREFIX_IMAGE_URL}AGS/Michelle/Beauty_notes._CB485920528_.jpg' />`,
        '（The above icon means: The effective period of this product is within 6 months/12 months after opening.）'
      ],
      [
        'In the United States  the Food and Drug Administration (FDA) does not regulate the marking of production dates or expiration dates on beauty products. Manufacturers of beauty products decide whether and how to mark the expiration date information.',
        "In Japan  only products that 'will deteriorate within 3 years under normal storage conditions' must be marked with a shelf life. If not marked  it means that the product has a shelf life of at least 3 years when unopened. For products without a production date  it is recommended to use them up within 12 months after opening. The above information is for your reference."
      ]
    ]
  ]
};

const customsClearanceTipData = {
  title: 'Submit ID Information Required for Customs Clearance',
  paragraphs: [
    'Policy Reminder: When purchasing Global Stores products  you need to submit the second-generation ID card information of the purchaser for customs clearance declaration and real-name verification. Please fill in the real name consistent with the second-generation ID card  and ensure that the purchaser (the person placing the order) and the payer (the owner of the payment account) have consistent identity information. Otherwise  it will affect customs clearance. Currently  only the verification of the second-generation ID card information of Chinese residents is supported.'
  ]
};

export const DP_AMAZON_TIPS_KEY = Object.freeze({
  SIZE_CHART: 'SIZE_CHART',
  UNIT_CONVERSION: 'UNIT_CONVERSION_TABLE',
  ELECTRICAL_VOLTAGE: 'ELECTRICAL_VOLTAGE_USAGE_INSTRUCTION',
  BEAUTY_SHOPPING: 'BEAUTY_SHOPPING_GUIDE',
  CUSTOMS_CLEARANCE: 'CUSTOMS_CLEARANCE_INFO'
});

export default {
  unitConversion: {
    TITLE: PAGE_TITLE_NAME.UNIT_CONVERSION_TABLE,
    CONTENT: `<div class="detail-page-form-wrapper">${unitConversionTipData.images
      .map(image => `<img src='${image}'/>`)
      .join('')}</div>
      `
  },
  electricalVoltage: {
    TITLE: PAGE_TITLE_NAME.ELECTRICAL_VOLTAGE_USAGE_INSTRUCTION,
    CONTENT: `<div class="detail-page-form-wrapper"><h3>${
      electricalVoltageTipData.title
    }</h3>${electricalVoltageTipData.paragraphs
      .map((paragraphs, index) => {
        return `${paragraphs
          .map(paragraph => {
            return `<p>${paragraph}</p>`;
          })
          .join('')}
           <img src="${electricalVoltageTipData.images[index]}"></img>
           <ol>${electricalVoltageTipData.lists[index]
             .map(list => {
               return `<li>${list}</li>`;
             })
             .join('')}<ol>
          `;
      })
      .join('')}</div>`
  },
  beautyShopping: {
    TITLE: PAGE_TITLE_NAME.BEAUTY_SHOPPING_GUIDE,
    CONTENT: `<div class="detail-page-form-wrapper"><h3>${
      beautyShoppingTipData.title
    }</h3>${beautyShoppingTipData.paragraphs
      .map((paragraph, index) => {
        return `<div>${paragraph}</div><div><h4 class="list-title-small tip-spacing-mini">${
          beautyShoppingTipData.lists[index]
        }</h4><div>${beautyShoppingTipData.listParagraphs[index]
          .map(
            listParagraphs =>
              `<div class="tip-spacing-mini">${listParagraphs
                .map(listParagraph => listParagraph)
                .join('')}</div>`
          )
          .join('')}</div></div>`;
      })
      .join('')}</div>`
  },
  customsClearanceInfo: {
    TITLE: PAGE_TITLE_NAME.CUSTOMS_CLEARANCE_INFO,
    CONTENT: `<div class="detail-page-form-wrapper"><h3>${
      customsClearanceTipData.title
    }</h3>${customsClearanceTipData.paragraphs
      .map(paragraph => `<p>${paragraph}</p>`)
      .join('')}</div>`
  }
};
